const foodConfig = {
  MENU_NAME_LIMIT: '30',
  MERCHANT_NAME_LIMIT: '20',
  MERCHANT_NAME_LINE_2_LIMIT: '20',
  INTRODUCE_MERCHANT_LIMIT: '20',
  INTRODUCE_MERCHANT_LINE_2_LIMIT: '20',
  BRANCH_NAME_LIMIT: '25',
};

export default foodConfig;
